import { combineReducers } from 'redux';

import editRecipe from './editrecipe/reducer';

export default combineReducers({
  editRecipe,
});



// WEBPACK FOOTER //
// ./src/pages/managerecipe/state/reducer.js